"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

require("core-js/modules/es.array.map.js");

require("core-js/modules/es.parse-int.js");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _color = _interopRequireDefault(require("color"));

var _useColors = _interopRequireDefault(require("../../hooks/useColors"));

var _MenuItem = _interopRequireDefault(require("./MenuItem"));

require("./styles.less");

var styles = {
  "popover": "meepshop-meep-ui__submenu-dropdownMenu-styles__popover",
  "groupPopover": "meepshop-meep-ui__submenu-dropdownMenu-styles__groupPopover",
  "menu": "meepshop-meep-ui__submenu-dropdownMenu-styles__menu",
  "menuItem": "meepshop-meep-ui__submenu-dropdownMenu-styles__menuItem",
  "arrow": "meepshop-meep-ui__submenu-dropdownMenu-styles__arrow"
};

var MenuContent = function MenuContent(_ref) {
  var pages = _ref.pages,
      menuSettings = _ref.menuSettings;
  // 色彩配置
  var colors = (0, _useColors["default"])();
  var submenuFontSize = parseInt(menuSettings.submenuFontSize || 16, 10); // 16px 為 top 及 bottom padding 高度

  var itemHeight = Math.max(submenuFontSize * 1.5 + 16, 38);
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: styles.menu,
    style: {
      '--submenu-font-size': submenuFontSize ? "".concat(submenuFontSize, "px") : '16px',
      '--submenu-color': 'var(--color-3)',
      '--submenu-background-color': 'var(--color-2)',
      '--submenu-background-color-hover': (0, _color["default"])(colors[1]).darken(0.05),
      maxHeight: itemHeight * 8
    }
  }, pages.map(function (page) {
    return /*#__PURE__*/_react["default"].createElement(_MenuItem["default"], {
      key: page.id,
      page: page,
      menuSettings: menuSettings,
      ContentComponent: MenuContent
    });
  }));
};

var _default = MenuContent;
exports["default"] = _default;